module.exports = __webpack_public_path__ + "img/ban3.d4e0e50f.jpg";